import { render } from "./information.vue?vue&type=template&id=248c4f52&scoped=true"
const script = {}

import "./information.vue?vue&type=style&index=0&id=248c4f52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248c4f52"]])

export default __exports__